import React from 'react';
import PropTypes from 'prop-types';

export const BranchShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const EmployeeShape = PropTypes.shape({
  id: PropTypes.string,
  customerId: PropTypes.string,
  businessId: PropTypes.string,
  businessDba: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  branches: PropTypes.arrayOf(BranchShape)
});

export const LocationShape = PropTypes.shape({
  id: PropTypes.number,
  lat: PropTypes.number,
  lng: PropTypes.number,
  name: PropTypes.string,
  address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  timeZone: PropTypes.string
});

export const FormErrorShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired
});

export const MessageDefinitionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired
});



/** WEBPACK FOOTER **
 ** ./src/main/js/common/react/Shapes.js
 **/